/**
 * PDP gallery helpers (aligned with maison/client + shop/client productImage patterns).
 */

export const PLACEHOLDER =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 1066'%3E%3Crect fill='%23e8e4e0' width='800' height='1066'/%3E%3C/svg%3E";

const isHttpUrl = (s) =>
  typeof s === 'string' && (s.startsWith('http://') || s.startsWith('https://'));

function parseImageEntry(entry) {
  if (!entry) return [];
  if (Array.isArray(entry)) {
    return entry.flatMap(parseImageEntry).filter(Boolean);
  }
  if (typeof entry === 'string') {
    const trimmed = entry.trim();
    if (isHttpUrl(trimmed)) return [trimmed];
    if (
      trimmed.startsWith('data:') ||
      trimmed.startsWith('/') ||
      trimmed.startsWith('.')
    )
      return [trimmed];
    if (trimmed.includes('static/media'))
      return [trimmed];
    if (trimmed.includes('.jpg') || trimmed.includes('.jpeg') || trimmed.includes('.png') || trimmed.includes('.webp'))
      return [trimmed];
    if (trimmed.startsWith('[')) {
      try {
        const parsed = JSON.parse(trimmed);
        return Array.isArray(parsed)
          ? parsed.flatMap(parseImageEntry).filter(Boolean)
          : [];
      } catch {
        return [];
      }
    }
    return trimmed ? [trimmed] : [];
  }
  return [];
}

export function normalizeImageUrl(img) {
  if (img == null || img === '') return PLACEHOLDER;
  const urls = parseImageEntry(img);
  return urls.length > 0 ? urls[0] : PLACEHOLDER;
}

/**
 * Gallery image list — supports API `images[]` or static catalog `image` / `hoverImage`.
 */
export function getProductImagesArray(product) {
  if (!product) return [];
  const seen = new Set();
  const out = [];
  const push = (src) => {
    const urls = parseImageEntry(src);
    urls.forEach((u) => {
      if (!u || seen.has(u)) return;
      seen.add(u);
      out.push(u);
    });
  };

  if (Array.isArray(product.images) && product.images.length) {
    product.images.forEach(push);
  }
  push(product.image);
  push(product.hoverImage);

  return out;
}
